import { Component, OnInit,Input } from '@angular/core';

import { HelperService,ErrorClass } from '../../../api/helper.service'

//Cart imports
import { CartService } from '../../../api/cart.service'
import { CartClass } from '../../../class/cartclass'

//Payment Imports
import { PaymentService } from '../../../api/payment.service'
import { PaymentClass } from '../../../class/paymentclass'

//Fundraiser Imports
import { FundraiserService } from '../../../api/fundraiser.service'
import { FundraiserClass,FdDetail } from '../../../class/fundraiserclass'

//Item Search
import { ItemWebsiteService } from '../../../api/item-website'
import { Items } from '../../../class/itemclassweb'
import { DropDownClass } from '../../../class/dropdownclass';

import { FileService } from '../../../api/file.service'


//Recaptcha
import { RecaptchaService } from '../../../api/recaptcha.service'
import { JsonPipe } from '@angular/common';

declare var grecaptcha: any;


@Component({
  selector: 'app-website',
  templateUrl: './website.component.html',
  styleUrls: ['./website.component.scss']
})
export class WebsiteComponent implements OnInit {

 item_list: Items[] = []
 need_list: DropDownClass = new DropDownClass
 category_list: DropDownClass = new DropDownClass


 @Input() qty_selected:number = 1;

  qty_number = [
      'Select',1,2,3,4,5
  ];

  //Cart Variables
  cart:CartClass = new CartClass

  constructor(
    private api:ItemWebsiteService,
    private cartAPI:CartService,
    private paymentAPI:PaymentService,
    private fundAPI:FundraiserService,
    private help:HelperService,
    private fileAPI:FileService,
    private recapService:RecaptchaService,
  ) { }

  ngOnInit() {


     
    // this.loadItemDropdown()
    // this.loadItems();
    // this.viewCartItems();
    // this.getPaymentMethods();
    // this.viewCurrentFundraiser();
    // this.viewFundraiserPublic(); //Public URL can be viewed without authentication
  }

  name:string  =''
  captcha_id:string=''

  testCaptcha(){
     const cap = grecaptcha.getResponse().then(
       (data) => {
         alert('Token Received:' + data)
       },
       (err) => {
         alert('Error')
       }
     )

     if(cap==''){
       alert('Captcha is required')
     }

     const body = {
       name:name,
       cap:cap
     }
     

     this.recapService.recaptcha(body).subscribe(
       (data:any) => {
         alert('success' + JSON.stringify(data))
       },
       (err:any) => {
         alert('Error:' + JSON.stringify(err))
       }
     )
  }



  @Input() currentInput;
  fileSelected:any 
  
  uploadFile(){
    // this.fileAPI.uploadFile(this.fileSelected).subscribe(
    //   (data) => {
    //     //alert('Success')
    //   },
    //   (err) => {
    //     //alert('Error:' + err)
    //   }
    // )
  }

  onFileSelected(event){
    
    if(event.target.files.length > 0) 
    {
      this.fileSelected = event.target.files[0]
    }
  }

  loadItemDropdown(){
    this.api.getItemDropdown().subscribe(
      (data) => {
        this.need_list = data['need_type']
        this.category_list = data['categories']
      },
      (err:ErrorClass) => {
        this.help.msgboxError("Error", err.error_message)
      }
    )
  }

  

  //*********************** ITEM SEARCH MODULE  *******************************/
  
   loadItems(){
      this.api.getItems().subscribe(
        (data:Items[]) =>{
          this.item_list = data
          this.item_list = this.item_list.map(
            (value) => {
              const v = value
              v.is_fundraise = false;
              return v
            }
          )

        },
        (err:ErrorClass) => {
          this.help.msgboxError("Loading Items Error", err.error_message)
        },
        ()=>{
          console.log('Complete')
        }
      )
   }

   validateDonationAmount(val){
     alert('Val:' + val)
   }

   addCartLoading = false
   donate(item_id, qty,donation_amount){
     const cart_item = {
        'item_id' : item_id,
        'qty_ordered' : qty,
        'donation_amount' : donation_amount
     }     
     this.addCartLoading = true
     this.cartAPI.addToCart(cart_item).subscribe(
       (data:any) => {
        this.help.msgbox('Added To Cart','Success')
        this.addCartLoading = false
        this.viewCartItems();
       },
       (err:ErrorClass) => {
        this.addCartLoading = false
         this.help.msgboxError("Error", err.error_message)
       }
     )
     
     //Add to cart add new transaction, 
     //item_id, qty, amount no items 
   }
  //*********************** ITEM SEARCH MODULE END  *******************************/


  //*********************** CART MODULE  *******************************/
   viewCartItems(){
      this.cartAPI.viewCartItems().subscribe(
        (data:CartClass) => {
           this.cart = data
        },
        (err:ErrorClass) => {
           this.help.msgboxError("Error", err.error_message)
        }
      )
   }
   
   updateQtyLoading:boolean = false;
   updateQtyCart(order_detail_id, qty_ordered){
      this.updateQtyLoading = true
      const cart_item = {
        'order_detail_id' : order_detail_id,
        'qty_ordered' : qty_ordered
      }

      this.cartAPI.updateQtyCart(cart_item).subscribe(
        (data) => {
          this.help.msgbox('Update Qty','Success')
           this.viewCartItems()
           this.updateQtyLoading = false
        },
        (err:ErrorClass) => {
          this.help.msgboxError("Error", err.error_message)
          this.updateQtyLoading = false
        }
      )

   }

   removeItemLoading:boolean = false;
   removeItemCart(order_detail_id){
     this.removeItemLoading = true
    this.cartAPI.removeItemCart(order_detail_id).subscribe(
      (data) => {
         this.help.msgbox('Remove Item','Success')
         this.removeItemLoading = false
         this.viewCartItems()
      },
      (err:ErrorClass) => {
        this.help.msgboxError("Error", err.error_message)
        this.removeItemLoading = false
      }
    )
   }
  //*********************** CART MODULE END *******************************/

  
  //*********************** Payment MODULE  *******************************/
  payment_method_list:PaymentMethodClass = new PaymentMethodClass
  payment_method_selected = 1;

  payment:PaymentClass = new PaymentClass
  payment_redirect:boolean = false
   getPaymentMethods(){
      this.paymentAPI.getPaymentMethods().subscribe(
        (data:PaymentMethodClass) => {
           this.payment_method_list = data
        },
        (err:ErrorClass) => {
          this.help.msgboxError("Error", err.error_message)
        }
      )
   }

   selectedMethod(pm_sel){
     this.payment_method_selected = pm_sel
     alert(pm_sel)
   }

   merchant_id = '300029';
   business = 'wvphilippines@wvi.org';

   hide_pesopay = true
   hide_paypal = true

   pmShow(){
      if(this.payment_method_selected==1){
        this.hide_pesopay = false
        this.hide_paypal = true
      }else if(this.payment_method_selected==2){
        this.hide_pesopay = true
        this.hide_paypal = false
      }
   }

   checkout(mode='live'){
     const pm = {
       'payment_method': this.payment_method_selected,
       'cart_items': this.cart.order_details
     }
     this.payment_redirect = true
     this.paymentAPI.checkout(pm).subscribe(
       (data:PaymentClass) => {
          this.payment = data
          
          //Redirect to payment gateway
          //const v =document.querySelector('input[name="amount"]').value()
          if(mode=='test'){
            this.merchant_id = '1029'
            this.business = 'sb-kv5yd1776433@business.example.com'
          }
           setTimeout(
             () => {
              if(mode=='test'){
                document.forms['pesopayForm'].action = "https://test.pesopay.com/b2cDemo/eng/payment/payForm.jsp";
                document.forms['paypalForm'].action = "https://www.sandbox.paypal.com/cgi-bin/webscr";
              }
              if(this.payment_method_selected == 1){
                document.forms["pesopayForm"].submit();
              }else if(this.payment_method_selected == 2){
                document.forms["paypalForm"].submit();
              }
             }, 50
           )

       },
       (err:ErrorClass) => {
           this.payment_redirect = false
          this.help.msgboxError("Error", err.error_message)
       }
     )
     
   }

  //*********************** END Payment MODULE  *******************************/

  //*********************** Fundraiser MODULE  *******************************/
   fundraiser_item_id = [];
   fundraiser:FundraiserClass  = new FundraiserClass
   fundraiser_public:FundraiserClass  = new FundraiserClass
   fundriase_total = 0;
   removeItemFundLoading:boolean = false
   @Input() fundMaster:FundSaveClass = new FundSaveClass

   @Input() fundraiser_id = 1;

   addItemFundraise(i:Items){
      if(i.is_fundraise){
        this.fundraiser_item_id.push(i.id)
      }else{
        this.fundraiser_item_id = this.fundraiser_item_id.filter(
          (val) => {
             if(val!=i.id){
               return val
             }
          }
        )


      }
   }
   addToFundraiser(){
      //Loop through each items with check ? then push through fundraiser_item_id
      const item_ids = {
       'item_ids' :  this.fundraiser_item_id
      }
      this.fundAPI.addFundraiser(item_ids).subscribe(
        (data:any) => {
          this.help.msgbox("Success","Created a fundraiser")
          this.viewCurrentFundraiser()
        },
        (err:ErrorClass) => {
          this.help.msgboxError("Error", err.error_message)
        }
      )
   }

   viewCurrentFundraiser(){
     this.fundAPI.viewCurrentFundraiser().subscribe(
       (data:FundraiserClass) => {
        this.fundraiser_item_id = [];
         this.fundraiser = data
         this.pushItemFundraiser(this.fundraiser.fd_details)
         
       },
       (err:ErrorClass) => {
         this.help.msgboxError("Error", err.error_message)
       }
     )
   }

   async pushItemFundraiser(fd_details:FdDetail[]){
      //Get all item_ids
       fd_details.map(
        async (item_id:FdDetail) => {
          await this.itemFundraiserChecker(item_id)
          this.fundraiser_item_id.push(item_id.item_id)
        }
      )
      
   }

   async itemFundraiserChecker(item_id:FdDetail){
     
    this.item_list.map(
        async (val:Items,index) => {
          const newval = val
          if(newval.id == item_id.item_id){
            newval.is_fundraise = true
            console.log('Is Fundraise True: ' + newval.id)
          }else{
            newval.is_fundraise = false
          }
          this.item_list[index] = newval
          return newval
        }
    )
    
    console.log('Item Fund Checker' , this.item_list)
   }


   removeItemFund(fd_id){
     alert(fd_id)
    this.removeItemFundLoading = true
      this.fundAPI.removeItemFundraiser(fd_id).subscribe(
        (data) => {
           this.help.msgbox("Item Removal","Success")
           this.removeItemFundLoading = false
           this.viewCurrentFundraiser();
        },
        (err:ErrorClass) => {
           this.help.msgboxError("Error",err.error_message)
           this.removeItemFundLoading = false
        }
      )
   }

   saveFundraiser(){
      const fund = this.fundMaster
      //Finalize
      this.fundAPI.saveFundraiser(fund).subscribe(
        async (data:any) => {
          await this.help.msgbox("Saving Success", "Success")
          this.viewCurrentFundraiser()
        },
        (err:ErrorClass) => {
           this.help.msgboxError("Error", err.error_message)
        }
      )
   }

   viewFundraiserPublic(){
     //Use Fundraiser ID
     const fund_id = this.fundraiser_id

     this.fundAPI.viewPublicFundraiser(fund_id).subscribe(
       (data:FundraiserClass) => {
         this.fundraiser_public = data
         this.fundraiser_public.fd_details = this.fundraiser_public.fd_details.map(
           (val:FdDetail) => {
            val.qty_ordered = 0
            val.donate_amount = ""
             return val
           }
         )
       },
       (err:ErrorClass) => {
         this.help.msgboxError("Error", err.error_message)
       }
     )
   }


   addCartFundraiser(){
     //Get the fd_detail_id
     //Get the item_id
     let pushCart = []

     this.fundraiser_public.fd_details.map(
      (val:FdDetail) => {
        if(val.donate_amount !=''){
          const amt:number = Number(val.donate_amount)
          if(this.help.isNumber(amt)){
              //If item has amount push to cart
              const item = {
                'fundraiser_detail_id' : val.fundraising_detail_id,
                'item_id' : val.item_id,
                'qty_ordered' : val.qty_ordered,
                'donation_amount' : val.donate_amount
              }
              pushCart.push(item)
          }
        }
      }
    )

    alert(JSON.stringify(pushCart))


   }


   computeFundraise(){
     this.fundriase_total = 0;
     
      this.fundraiser_public.fd_details.map(
        (val:FdDetail) => {
          if(val.donate_amount !=''){
            const amt:number = Number(val.donate_amount)
            if(this.help.isNumber(amt)){
              if(amt > 0){
                 this.fundriase_total += amt
              }else{
                this.help.msgboxError("Error","Amount should be greater than 500")
              }
            }
          }
        }
      )
   }

   


   

  //*********************** END Fundraiser  MODULE  *******************************/


}


class ItemCart {
  item_id:number;
  qty:number;
  amount:number;
}

class FundSaveClass{
   goal_amount:number;
   mesage:string;
}

class PaymentMethodClass{
   id:number;
   method_name:string;
}

